import React from 'react';
import { arrayOf, string, bool } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { MILESTONES, getEarnedMilestones } from './milestoneUtils';
import css from './MilestoneBadge.module.css';

/**
 * MilestoneBadge — displays earned user achievement badges.
 *
 * Usage (in ProfilePage):
 *   {features.userMilestones && (
 *     <MilestoneBadge milestoneIds={user.attributes.protectedData.milestones || []} />
 *   )}
 *
 * @param {string[]} props.milestoneIds — array of earned milestone IDs
 * @param {boolean} [props.compact] — show only icons, no labels
 */
const MilestoneBadge = ({ milestoneIds, compact, className }) => {
  const earned = getEarnedMilestones(milestoneIds);
  if (earned.length === 0) return null;

  return (
    <div className={classNames(css.root, compact && css.compact, className)}>
      {earned.map(milestone => (
        <div key={milestone.id} className={css.badge} title={milestone.description}>
          <span className={css.icon}>{milestone.icon}</span>
          {!compact && (
            <span className={css.label}>
              <FormattedMessage id={milestone.labelKey} />
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

MilestoneBadge.defaultProps = { compact: false, className: null };
MilestoneBadge.propTypes = {
  milestoneIds: arrayOf(string).isRequired,
  compact: bool,
  className: string,
};

export default MilestoneBadge;
